import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import requester from "../../utils/requester";
import FramerWebsite from "../../components/FramerWebsite";
import backArrowLogo from "../../assets/backArrow.svg";

const DEPT_ENDPOINTS = {
  "sea-trip": "/albums/getAlbumImages",
  "grand-aquarium": "/aquarium/get-ticket-images",
  "media": "/media/get-ticket-images",
  "dolphin-world": "/dolphin-house/get-ticket-images",
  "dolphin-house": "/dolphin-house/get-ticket-images",
};

export default function DeptGetYourMomentsPage({ service }) {
  const { code } = useParams();
  const [album, setAlbum] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const endpoint = DEPT_ENDPOINTS[service.route] || "/albums/getAlbumImages";
  const isMedia = service.route === "media";

  function handleFormSubmit(submittedCode) {
    if (!submittedCode || isLoading) return;
    setIsLoading(true);

    requester()
      .get(endpoint, { params: { code: submittedCode } })
      .then((res) => {
        setIsLoading(false);
        const albumData = res?.data?.data;
        if (albumData?.serviceType === "album") {
          setAlbum(albumData);
        } else if (albumData?.serviceType === "video") {
          window.open(albumData?.videoUrl, "_top");
        } else if (
          albumData?.serviceType === "photo" ||
          albumData?.tripType === "grand-aquarium" ||
          albumData?.tripType === "media" ||
          albumData?.tripType === "dolphin-house"
        ) {
          window.open(albumData?.albumSharedLink, "_top");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.info(
          <div style={{ textAlign: "center" }}>
            {err.response?.status === 402
              ? "Hi👋, kindly complete your payment as we agreed with you, thanks"
              : isMedia
              ? "Hi👋, your package will be available soon, thanks"
              : "Hi👋, your package will be available within 24 hours, thanks"}
          </div>
        );
      });
  }

  if (album) {
    return (
      <div
        style={{
          height: "100vh",
          background: "#1a1a1a",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "#2c2c2c",
            borderRadius: "1.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "2rem",
            minWidth: 300,
            gap: "1.5rem",
          }}
        >
          <div
            onClick={() => setAlbum(null)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              cursor: "pointer",
              alignSelf: "flex-start",
              color: "white",
            }}
          >
            <img src={backArrowLogo} alt="back" />
            <span>Back</span>
          </div>
          <a
            className="button"
            href={album.albumSharedLink}
            target="_blank"
            rel="noreferrer"
            style={{ width: "100%", textAlign: "center", textDecoration: "none" }}
          >
            Photo
          </a>
          <a
            className="button"
            href={album.videoUrl}
            target="_blank"
            rel="noreferrer"
            style={{ width: "100%", textAlign: "center", textDecoration: "none" }}
          >
            Video
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: "relative", height: "100%" }}>
      <FramerWebsite
        page="/get-your-moments"
        initialCode={code}
        onFormSubmit={handleFormSubmit}
      />
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontSize: "1.25rem",
          }}
        >
          Loading...
        </div>
      )}
    </div>
  );
}
